module.exports = __webpack_public_path__ + "static/buyer-store-details-5c7b105f7f0591be9b12eab469e69533.gif";